import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

const WHATSAPP_NUMBER = '905454535949'; // +90 545 453 59 49

const WhatsAppIcon = ({ className = '' }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.003 3C9.376 3 4 8.376 4 15.003c0 2.357.685 4.555 1.864 6.404L4 28l6.768-1.776a11.94 11.94 0 0 0 5.235 1.21h.005C22.633 27.434 28 22.057 28 15.43c0-3.213-1.252-6.232-3.524-8.504A11.93 11.93 0 0 0 16.003 3Zm0 21.879h-.004a9.93 9.93 0 0 1-5.062-1.388l-.363-.215-3.94 1.034 1.05-3.84-.236-.394a9.92 9.92 0 0 1-1.516-5.073C5.932 9.46 10.466 4.929 16 4.929c2.65 0 5.142 1.033 7.018 2.91A9.876 9.876 0 0 1 25.93 14.857c-.002 5.534-4.535 10.022-9.927 10.022Zm5.452-7.498c-.299-.149-1.768-.872-2.042-.971-.274-.1-.473-.149-.672.15-.199.299-.771.97-.945 1.169-.174.199-.348.224-.647.075-.299-.15-1.263-.466-2.405-1.485-.889-.793-1.49-1.772-1.664-2.07-.174-.299-.018-.46.131-.609.135-.134.299-.348.448-.522.149-.174.199-.299.298-.498.1-.199.05-.373-.025-.522-.075-.149-.672-1.619-.921-2.218-.242-.582-.488-.503-.671-.512l-.572-.01c-.199 0-.522.075-.796.373-.274.299-1.045 1.022-1.045 2.492 0 1.47 1.07 2.892 1.22 3.091.149.199 2.108 3.222 5.108 4.515.714.309 1.272.493 1.706.632.717.228 1.37.196 1.886.119.575-.086 1.768-.722 2.018-1.42.249-.697.249-1.296.174-1.42-.074-.124-.273-.199-.572-.348Z"/>
  </svg>
);

const WhatsAppButton = () => {
  const { lang } = useLang();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const greeting = lang === 'tr'
    ? 'Merhaba, ROLVIA DESIGN web sitesinden ulaşıyorum. 3D baskı hakkında bilgi almak istiyorum.'
    : 'Hello, I am reaching out from the ROLVIA DESIGN website. I would like to get information about 3D printing.';

  const tooltipText = lang === 'tr' ? 'WhatsApp ile yazışın' : 'Chat on WhatsApp';

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(greeting)}`;

  return (
    <div className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[60] flex items-end gap-2 group" style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      {tooltipOpen && (
        <div className="hidden sm:flex items-center bg-zinc-900 text-white text-sm font-medium px-3 py-2 rounded-lg shadow-lg mb-1 animate-in fade-in slide-in-from-right-2">
          <span>{tooltipText}</span>
          <button
            onClick={(e) => { e.preventDefault(); setTooltipOpen(false); }}
            className="ml-2 text-zinc-400 hover:text-white"
            aria-label="close"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setTooltipOpen(true)}
        onFocus={() => setTooltipOpen(true)}
        aria-label={tooltipText}
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden="true" />
        <WhatsAppIcon className="relative w-7 h-7" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
